import React from 'react';
import styled from 'styled-components';
import utility from '../../assets/css/utility';
import cssVar from '../../assets/css/variables';
import { logCleverTapEvent } from '../Analytics/Clevertap/Clevertap';
import ClevertapConstant from '../Analytics/Clevertap/ClevertapConstant';
import Modal from '../UIComponent/Modal/Modal';

const ErrorContainer = styled.div`
  background-color: ${cssVar.colorWhite};
  height: 100vh;
  ${utility.flexVertical};
  ${utility.alignCenter};
	${utility.justifyCenter};
	svg{
		height: 15.0rem;
		width: 15.0rem;
		@media screen and (min-width: ${cssVar.mobile}) {
			height: 20.0rem;
			width: 20.0rem;
		}
	}
`;
const Text = styled.p`
  ${utility.fontXxl};
  ${utility.colorBaseSecondary};
	${utility.fontSemiBold};
	${utility.txtC};
	@media screen and (min-width: ${cssVar.mobile}) {
		${utility.h1};		
	}
`;

class ErrorWrapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error, info) {
        console.log(error)
		this.setState({ hasError: error });
        logCleverTapEvent({
            NAME: ClevertapConstant.APP_ERROR,
            PAYLOAD: {
                COMPONENT_STACK: info?.componentStack || "UNDEFINED",
                ERROR_STACK: error?.stack || "UNDEFINED",
                ERROR_MESSAGE: error?.message || "UNDEFINED"
            }
        })
	}
	
	render() {
		const { CatchError } = this.props
		if (this.state.hasError || CatchError) {
			return (
				<React.Fragment>
					<React.Fragment>
						<ErrorContainer>
							<Modal reloadPage></Modal>
						</ErrorContainer>
					</React.Fragment>
				</React.Fragment>
			);
		}
		return this.props.children;
	}
}

export default ErrorWrapper;